import SignalsTooltipTableView from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/shared/SignalsTooltipTableView/SignalsTooltipTableView";
import styled from "styled-components";

export const StyledAdNetworksTooltipTableView = styled(SignalsTooltipTableView)`
    &.wide-tooltip-table {
        min-width: 270px;

        & .MiniFlexTable-column {
            flex-grow: 1 !important;
        }
    }
`;
